import React from "react";
import "./Proceed_to_Checkout.css";
// import Stay_Connected from "../home/stay_Connected/Stay_Connected";
import Breadcrumb_comp from "../common-components/breadcrumb-comp/Breadcrumb_comp";
import CheckoutStepForm from "./checkoutStepForm/CheckoutStepForm";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { Navigate, useNavigate } from "react-router-dom";

function Proceed_to_Checkout() {
  const breadcrumbs = [
    { label: "Home", link: "/", isActive: false },
    { label: "Cart Product", link: "/product-cart", isActive: false },
    { label: "Personal Details", link: "", isActive: true },
  ];

  const navigate = useNavigate();
  return (
    <>
      <section className="Proceed_to_Checkout">
        <Breadcrumb_comp breadcrumbs={breadcrumbs} />

        {/* <div className="container">
          <div className="back_holder" onClick={() => navigate(-1)}>
            <FontAwesomeIcon icon={faArrowLeft} className="back_icon" />
            <span>Back</span>
          </div>
        </div> */}

        <div className="Proceed_to_Checkout_step_form_holder">
          <div className="container">
            <CheckoutStepForm />
          </div>
        </div>

        {/* <Stay_Connected /> */}
      </section>
    </>
  );
}

export default Proceed_to_Checkout;
